export default __webpack_public_path__ + "static/media/packaged_fuel.95202cea.png";